import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { FaUser, FaSignInAlt, FaChevronDown, FaPhone,FaYoutube,  FaEnvelope, FaArrowRight, FaFacebookF, FaSpotify, FaLinkedinIn, FaInstagram, FaTimes, FaBars, FaTrophy } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import ComingSoonModal from './ComingSoonModal';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  font-family: 'Times New Roman', serif;
`;

const MainHeader = styled.div`
  background: #ffffff;
  padding: 0.5rem 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  height: 150px;
  font-family: 'Times New Roman', serif;
  overflow: visible !important;

  @media (max-width: 1366px) and (min-width: 769px) {
    height: 120px;
    padding: 0.3rem 3%;
    gap: 0.6rem;
    overflow: visible !important;
  }

  @media (max-width: 1200px) {
    height: auto;
    flex-wrap: wrap;
    padding: 1rem 5%;
    overflow: visible !important;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    padding: 0.5rem 3%;
    gap: 0.6rem;
    height: auto;
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    height: 75px !important;
    min-height: 75px !important;
    padding: 0.25rem 3% !important;
    flex-wrap: nowrap !important;
    background: #ffffff !important;
    border-bottom: 1px solid rgba(10, 77, 104, 0.1) !important;
    overflow: visible !important;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-shrink: 0;
  font-family: 'Times New Roman', serif;
 
  img {
    height: 50px;
    width: auto;
    filter: none;
  }

  .new-logo {
    height: 110px;
    width: auto;
  }
 
  h1 {
    font-size: 1.2rem;
    font-weight: 700;
    color: #3730A3;
    line-height: 1.2;
    font-family: 'Times New Roman', serif;
 
    span {
      display: block;
      font-size: 0.7rem;
      font-weight: 400;
      color: #3730A3;
      letter-spacing: 1px;
      font-family: 'Times New Roman', serif;
    }
  }

  @media (max-width: 1366px) and (min-width: 769px) {
    gap: 1.2rem;
 
    img {
      height: 40px;
    }
 
    .new-logo {
      height: 85px;
    }
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    gap: 1rem;
 
    img {
      height: 40px;
    }
 
    .new-logo {
      height: 75px;
    }
  }

  @media (max-width: 768px) {
    gap: 0.6rem;
 
    img {
      height: 25px !important;
    }
 
    .new-logo {
      height: 28px !important;
    }
 
    h1 {
      display: none !important;
    }
  }
`;

const TrainerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
  min-width: 400px;
  max-width: 480px;
  margin-right: 0.5rem;
  margin-left: 7rem;
  font-family: 'Times New Roman', serif;

  @media (max-width: 1366px) and (min-width: 769px) {
    min-width: 320px;
    max-width: 380px;
    gap: 0.6rem;
    margin-right: 0.3rem;
    margin-left: 1rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    min-width: 100%;
    max-width: 100%;
    margin-right: 0;
    margin-left: 0;
    order: 3;
  }

  @media (max-width: 1200px) {
    min-width: 100%;
    max-width: 100%;
    margin-right: 0;
    margin-left: 0;
  }

  /* Hidden on phones — the trainer details live in the slide-out menu instead,
     so they no longer squish into a stray column in the header. */
  @media (max-width: 768px) {
    display: none !important;
  }

  @media (max-width:1024px) and (min-width:769px) {
    min-width:100% !important;
    max-width:100% !important;
    display:flex !important;
    justify-content:center !important;
    align-items:center !important;
    margin:0 auto !important;
  }
`;

const TrainerDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  font-family: 'Times New Roman', serif;
  min-width: 320px;
  padding-left: 3.5rem;

  @media (max-width: 1366px) and (min-width: 769px) {
    min-width: 280px;
    padding-left: 3rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    min-width: 100%;
    padding-left: 0;
    align-items: center;
    text-align: center;
  }

  @media (max-width: 768px) {
    min-width: auto !important;
    display: flex !important;
    flex-direction: column !important;
    padding-left: 0 !important;
  }
`;

const TrainerName = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.5;
  font-family: 'Times New Roman', serif;
  color: #3730A3;
  margin-bottom: 0;

  @media (max-width: 1366px) and (min-width: 769px) {
    font-size: 1.05rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 1rem;
  }

  @media (max-width: 768px) {
    font-size: 0.7rem !important;
    line-height: 1.1 !important;
  }
`;

const InfoLine = styled.div`
  font-size: 0.88rem;
  color: #4a4a6a;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  line-height: 1.5;
  font-weight: 600;
  font-family: 'Times New Roman', serif;
 
  .arrow {
    color: #3730A3;
    font-size: 0.8rem;
    font-weight: 700;
    flex-shrink: 0;
  }
 
  @media (max-width: 1366px) and (min-width: 769px) {
    font-size: 0.75rem;
    line-height: 1.4;
 
    .arrow {
      font-size: 0.7rem;
    }
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 0.75rem;
    justify-content: center;
  }

  @media (max-width: 768px) {
    font-size: 0.5rem !important;
    gap: 0.2rem !important;

    .arrow {
      font-size: 0.45rem !important;
    }
  }
`;

const SideLogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  margin-right: 8rem;
  flex-shrink: 0;

  @media (max-width: 1366px) and (min-width: 769px) {
    margin-right: 2.5rem;
    gap: 0.4rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    margin-right: 0;
    order: 2;
  }

  @media (max-width: 768px) {
    margin-right: 0.5rem;
    gap: 0.3rem;
  }
`;

const SideLogo = styled.img`
  height: 150px;
  width: auto;
  flex-shrink: 0;

  @media (max-width: 1366px) and (min-width: 769px) {
    height: 120px;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    height: 100px;
  }

  @media (max-width: 768px) {   
    height: 30px !important;
  }
`;

const BlinkingBadge = styled.div`
  background: #ff4444;
  color: white;
  font-size: 0.55rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  white-space: nowrap;
  animation: blink 1.2s ease-in-out infinite;
  font-family: 'Times New Roman', serif;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 10px rgba(255, 68, 68, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  z-index: 5;
  
  @keyframes blink {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
  }

  @media (max-width: 1366px) and (min-width: 769px) {
    font-size: 0.5rem;
    padding: 3px 8px;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 0.5rem;
    padding: 3px 8px;
  }

  @media (max-width: 768px) {
    font-size: 0.35rem;
    padding: 2px 5px;
  }
`;

const RightInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  min-width: 200px;
  flex-shrink: 0;
  font-family: 'Times New Roman', serif;

  @media (max-width: 1366px) and (min-width: 769px) {
    min-width: 180px;
    gap: 0.5rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    min-width: 100%;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    order: 4;
    gap: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid rgba(55, 48, 163, 0.1);
  }

  @media (max-width: 1200px) {
    width: 100%;
    min-width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 768px) {
    display: none !important;
  }
`;

const ContactInfoCompact = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-family: 'Times New Roman', serif;

  @media (max-width: 1366px) and (min-width: 769px) {
    gap: 0.4rem;
  }

  @media (max-width: 1200px) {
    flex-direction: row;
    gap: 1rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    flex-direction: row;
    gap: 1.5rem;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
`;

const CompactContactItem = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #3730A3;
  text-decoration: none;
  font-size: 1.0rem;
  transition: all 0.3s ease;
  padding: 0.2rem 0.4rem;
  border-radius: 20px;
  font-family: 'Times New Roman', serif;
 
  svg {
    color: #3730A3;
    font-size: 0.9rem;
  }

  &:hover {
    background: rgba(55, 48, 163, 0.08);
    transform: translateX(3px);
  }

  @media (max-width: 1366px) and (min-width: 769px) {
    font-size: 0.85rem;
    padding: 0.2rem 0.3rem;
 
    svg {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 0.85rem;
    padding: 0.2rem 0.4rem;
 
    svg {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 1200px) {
    padding: 0.2rem 0.6rem;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 1366px) and (min-width: 769px) {
    gap: 0.6rem;
  }

  @media (max-width: 1200px) {
    justify-content: flex-end;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    gap: 0.8rem;
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    display: none !important;
  }
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(55, 48, 163, 0.1);
  color: #3730A3;
  transition: all 0.3s ease;
  font-size: 0.9rem;
 
  &:hover {
    background: #3730A3;
    color: #ffffff;
    transform: translateY(-3px);
  }

  @media (max-width: 1366px) and (min-width: 769px) {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }
`;

const NavigationBar = styled.div`
  background: #0b0b77;
  padding: 0 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  position: relative;
  z-index: 999;
   font-family: 'Times New Roman', serif;

  @media (max-width: 1366px) and (min-width: 769px) {
    height: 38px;
    padding: 0 3%;
  }

  @media (max-width: 1024px) {
    overflow-x: auto;
    justify-content: flex-start;
 
    &::-webkit-scrollbar {
      display: none;
    }
  }

  @media (max-width: 768px) {
    display: none !important;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 1.8rem;
  height: 100%;

  @media (max-width: 1366px) and (min-width: 769px) {
    gap: 1.3rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    gap: 1.2rem;
  }
`;

const NavItem = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: white;
  font-size: 1.0rem;
  font-weight: 500;
  padding: 0.3rem 0;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  height: 100%;
  font-family: 'Times New Roman', serif;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: #a78bfa;
    transition: width 0.3s ease;
  }

  &:hover {
    color: #a78bfa;
 
    &:after {
      width: 100%;
    }
  }

  svg {
    font-size: 0.7rem;
  }

  @media (max-width: 1366px) and (min-width: 769px) {
    font-size: 0.85rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 0.8rem;
  }
`;

const NavLoginButton = styled.button`
  background: #ffff;
  color: #3730A3;
  border: none;
  padding: 0.3rem 1.2rem;
  border-radius: 30px;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  margin-left: auto;
  font-family: 'Times New Roman', serif;
 
  &:hover {
    background: #a78bfa;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(167, 139, 250, 0.3);
  }
 
  svg {
    font-size: 0.9rem;
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 0.8rem;
    padding: 0.25rem 1rem;
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  background: white;
  min-width: 260px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
  border-radius: 6px;
  padding: 0.4rem 0;
  z-index: 1001;
  border-top: 3px solid #a78bfa;
  display: ${props => props.isOpen ? 'block' : 'none'};

  &:before {
    content: '';
    position: absolute;
    top: -8px;
    left: 20px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #a78bfa;
  }

  &.dropdown-right {
    left: auto;
    right: 0;
 
    &:before {
      left: auto;
      right: 20px;
    }
  }
`;

const DropdownItem = styled.div`
  position: relative;
`;

const DropdownItemLink = styled(Link)`
  color: #2c3e50;
  padding: 0.6rem 1.5rem;
  text-decoration: none;
  display: block;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  font-family: 'Times New Roman', serif;

  &:hover {
    background: #f5f3ff;
    color: #3730A3;
  }
`;

const MobileBottomHeader = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex !important;
    background: #3730A3;
    height: 45px;
    padding: 0 3%;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba(167, 139, 250, 0.2);
  }
`;

const MobileContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const MobileContactItem = styled.a`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  color: white;
  text-decoration: none;
  font-size: 0.75rem;
  font-family: 'Times New Roman', serif;
 
  svg {
    color: #a78bfa;
    font-size: 0.9rem;
  }
`;

const MobileLoginButton = styled.button`
  background: #a78bfa;
  color: #3730A3;
  border: none;
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  cursor: pointer;
  font-family: 'Times New Roman', serif;
 
  &:hover {
    background: white;
  }
 
  svg {
    font-size: 0.7rem;
  }
`;

const MobileMenuToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
 
  svg {
    color: #a78bfa;
  }
`;

const MobileMenuOverlay = styled.div`
  display: none;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    z-index: 9999;
    display: ${props => props.className?.includes('show') ? 'block' : 'none'};
  }
`;

const MobileMenu = styled.div`
  display: none;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: ${props => props.className?.includes('open') ? '0' : '-100%'};
    width: 85%;
    max-width: 320px;
    height: 100vh;
    background: white;
    z-index: 10000;
    overflow-y: auto;
    transition: right 0.3s ease;
    box-shadow: -5px 0 20px rgba(0,0,0,0.2);
    display: block;
  }
`;

const Header = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);
  const navigate = useNavigate();

 const handleHomeClick = (e) => {
  if (window.location.pathname === '/') {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  setMobileMenuOpen(false);
};

const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleMouseEnter = (index) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (navItems[index]?.hasDropdown) {
      setOpenDropdown(index);
    }
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      if (!dropdownRef.current?.matches(':hover')) {
        setOpenDropdown(null);
      }
    }, 200);
  };

  const handleCertificateClick = () => {
    // Try different approaches to open the PDF
    const pdfUrl = '/certificates/trainer-certificate.pdf';
    
    // Method 1: Open in new tab
    window.open(pdfUrl, '_blank');
    
    // Method 2: If above doesn't work, try this fallback
    // const link = document.createElement('a');
    // link.href = pdfUrl;
    // link.target = '_blank';
    // link.click();
  };

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [mobileMenuOpen]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const navItems = [
    { title: 'Home', hasDropdown: false, path: '/' },
    { title: 'About LTU', hasDropdown: false, path: '/about-us' },
    { title: 'About Trainer', hasDropdown: false, path: '/our-trainers' },
    { title: 'CCS', hasDropdown: false, path: '/ccs' },
    { title: 'CDI', hasDropdown: false, path: '/cdi' },
    {
      title: 'Speciality Courses', hasDropdown: true,
      dropdown: [
         { name: 'Basic Medical Coding Training', path: '/basic-coding' },
         { name: 'Advanced Medical Coding Training', path: '/advanced-coding'},
         { name: 'ED / E&M Training', path: '/specialty/ed-em-training' },
         { name: 'Surgery Coding', path: '/surgery-coding' },
         { name: 'Inpatient DRG', path: '/inpatient-drg' }
      ]
    },
    { title: 'FAQ', hasDropdown: false, path: '/faq' },
    {
      title: 'Gallery', hasDropdown: true,
      dropdown: [
        { name: 'Hall of Achievers', path: '/gallery' },
        { name: 'Internal Events', path: '/internal-events' },
        { name: 'External Events', path: '/external-events' }
      ]
    },
 
    { title: 'Testimonials', hasDropdown: false, path: '/testimonials' },
    { title: 'Job Opportunities', hasDropdown: false, path: '/job-opportunities' },
    {
      title: 'More', hasDropdown: true,
      dropdown: [
        { name: 'Contact Us', path: '/contact-us' },
        { name: 'Blog', path: '/blog' },
        { name: 'Subscribe for updates', path: '/newsletter-signup' }
      ],
      align: 'right'
    }
  ];

  const mobileNavItems = [
    { title: 'Home', hasDropdown: false, path: '/' },
    { title: 'About LTU', hasDropdown: false, path: '/about-us' },
    { title: 'About Trainer', hasDropdown: false, path: '/our-trainers' },
    { title: 'CCS', hasDropdown: false, path: '/ccs' },
    { title: 'CDI', hasDropdown: false, path: '/cdi' },
    {
      title: 'Speciality Courses', hasDropdown: true,
      dropdown: [
         { name: 'Basic Medical Coding Training', path: '/basic-coding' },
         { name: 'Advanced Medical Coding Training', path: '/advanced-coding'},
         { name: 'ED / E&M Training', path: '/specialty/ed-em-training' },
         { name: 'Surgery Coding', path: '/surgery-coding' },
         { name: 'Inpatient DRG', path: '/inpatient-drg' }
      ]
    },
     { title: 'FAQ', hasDropdown: false, path: '/faq' },
     {
      title: 'Gallery', hasDropdown: true,
      dropdown: [
        { name: 'Hall of Achievers', path: '/gallery' },
        { name: 'Internal Events', path: '/internal-events' },
        { name: 'External Events', path: '/external-events' }
      ]
    },
    { title: 'Testimonials', hasDropdown: false, path: '/testimonials' },
    { title: 'Job Opportunities', hasDropdown: false, path: '/job-opportunities' },
 
    {
      title: 'More', hasDropdown: true,
      dropdown: [
        { name: 'Contact Us', path: '/contact-us' },
        { name: 'Blog', path: '/blog' },
        { name: 'Subscribe for updates', path: '/newsletter-signup' }
      ]
    }
  ];

  return (
    <HeaderContainer>
      <MainHeader>
        <LogoSection>
          <img
            className="new-logo"
            src="/images/new-logo.png"
            alt="New Logo"
          />
          <Link to="/" onClick={handleHomeClick}>
            <img
              src="/images/logo.png"
              alt="Learn Thru Us Academy"
              style={{ filter: 'brightness(0) saturate(100%) invert(11%) sepia(53%) saturate(5613%) hue-rotate(245deg) brightness(94%) contrast(103%)' }}
            />
          </Link>
        </LogoSection>

        <TrainerContent>
          <TrainerDetails>
            <TrainerName>Gaayatri Jayapal</TrainerName>
 
            <InfoLine>
              <span className="arrow">→</span> BSc, E-MBA, CCS-P, CCS, CDIP
            </InfoLine>
 
            <InfoLine>
              <span className="arrow">→</span> Founder of Learn Thru Us Academy
            </InfoLine>
 
            <InfoLine>
              <span className="arrow">→</span> AHIMA Approved CDI Trainer
            </InfoLine>
 
            <InfoLine>
              <span className="arrow">→</span> First trainer from India on CDI
            </InfoLine>
 
            <InfoLine>
              <span className="arrow">→</span> 5000+ students passed CCS
            </InfoLine>
          </TrainerDetails>
        </TrainerContent>

        <SideLogoContainer onClick={handleCertificateClick}>
          <SideLogo
            src="/images/side-logo.png"
            alt="Side Logo"
          />
          <BlinkingBadge>📄 Click Here</BlinkingBadge>
        </SideLogoContainer>

        <RightInfoContainer>
          <ContactInfoCompact>
            <CompactContactItem href="tel:+1234567890">
              <FaPhone /> <span>+1 (234) 567-890</span>
            </CompactContactItem>
            <CompactContactItem href="mailto:connect@learnthruus.com">
              <FaEnvelope /> <span>connect@learnthruus.com</span>
            </CompactContactItem>
          </ContactInfoCompact>
 
          <SocialIcons>
            <SocialIcon href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </SocialIcon>
            <SocialIcon href="https://spotify.com" target="_blank" rel="noopener noreferrer">
              <FaSpotify />
            </SocialIcon>
            <SocialIcon href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </SocialIcon>
            <SocialIcon href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </SocialIcon>
            <SocialIcon href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </SocialIcon>
          </SocialIcons>
        </RightInfoContainer>
      </MainHeader>

      <NavigationBar>
        <Nav>
          {navItems.map((item, index) => (
            <NavItem
              key={index}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <NavLink
            to={item.path || '#'}
            onClick={item.title === 'Home' ? handleHomeClick : undefined}
             >
             {item.title} {item.hasDropdown && <FaChevronDown />}
              </NavLink>
 
              {item.hasDropdown && (
                <Dropdown
                  ref={dropdownRef}
                  className={item.align === 'right' ? 'dropdown-right' : ''}
                  isOpen={openDropdown === index}
                >
                  {item.dropdown.map((dropItem, dropIndex) => (
                    <DropdownItem key={dropIndex}>
                      <DropdownItemLink to={dropItem.path}>
                        {dropItem.name}
                      </DropdownItemLink>
                    </DropdownItem>
                  ))}
                </Dropdown>
              )}
            </NavItem>
          ))}
        </Nav>
 
        <NavLoginButton onClick={() => {
          setShowComingSoon(true);
        }}>
          <FaSignInAlt /> Login
        </NavLoginButton>
      </NavigationBar>

      <MobileBottomHeader>
        <MobileContactInfo>
          <MobileContactItem href="tel:+1234567890">
            <FaPhone /> +1 (234) 567-890
          </MobileContactItem>
          <MobileContactItem href="mailto:info@learnthruus.com">
            <FaEnvelope /> info@learnthruus.com
          </MobileContactItem>
        </MobileContactInfo>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <MobileLoginButton onClick={() => {
            setShowComingSoon(true);
          }}>
            <FaSignInAlt /> Login
          </MobileLoginButton>
          <MobileMenuToggle onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </MobileMenuToggle>
        </div>
      </MobileBottomHeader>

      <MobileMenuOverlay className={mobileMenuOpen ? 'show' : ''} onClick={toggleMobileMenu} />

      <MobileMenu className={mobileMenuOpen ? 'open' : ''}>
        <div style={{ padding: '20px', background: 'linear-gradient(135deg, #3730A3 0%, #0b0b77 100%)', color: 'white' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <div>
              <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '700' }}>Gaayatri Jayapal</h4>
              <p style={{ margin: 0, fontSize: '0.7rem', opacity: 0.9, fontWeight: '600' }}>BSc, MBA, CCS-P, CCS, CDIP</p>
              <p style={{ margin: 0, fontSize: '0.7rem', opacity: 0.9, fontWeight: '600' }}>First trainer from India on CDI</p>
            </div>
          </div>
          <div style={{ background: 'rgba(167, 139, 250, 0.2)', border: '1px solid #a78bfa', borderRadius: '30px', padding: '0.3rem 1rem', fontSize: '0.7rem', display: 'inline-block', fontWeight: '600' }}>
            AHIMA Approved CDI Trainer
          </div>
        </div>

        <div style={{ padding: '20px', borderBottom: '1px solid #eee' }}>
          {mobileNavItems.map((item, index) => (
            <div key={index}>
              <div style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                {!item.hasDropdown ? (
                  <Link
                    to={item.path || '/'}
                    onClick={toggleMobileMenu}
                    style={{
                      fontWeight: 'bold',
                      color: '#333',
                      fontSize: '0.9rem',
                      textDecoration: 'none',
                      display: 'block',
                    }}
                  >
                    {item.title}
                  </Link>
                ) : (
                  <>
                    <div style={{ fontWeight: 'bold', color: '#333', fontSize: '0.9rem' }}>
                      {item.title}
                    </div>
                    <div style={{ marginLeft: '15px', marginTop: '5px' }}>
                      {item.dropdown.map((drop, i) => (
                        <Link
                          key={i}
                          to={drop.path}
                          style={{ display: 'block', padding: '5px 0', color: '#666', textDecoration: 'none', fontSize: '0.8rem' }}
                          onClick={toggleMobileMenu}
                        >
                          {drop.name}
                        </Link>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>

        <div style={{ padding: '20px', background: '#f8fafc' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#666', fontSize: '0.8rem', marginBottom: '0.5rem' }}>
            <FaPhone style={{ color: '#3730A3' }} /> +1 (888) 123-4567
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#666', fontSize: '0.8rem', marginBottom: '1rem' }}>
            <FaEnvelope style={{ color: '#3730A3' }} /> info@learnthruus.com
          </div>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
            <a href="https://facebook.com" style={{ color: '#3730A3' }}><FaFacebookF /></a>
            <a href="https://spotify.com" style={{ color: '#3730A3' }}><FaSpotify /></a>
            <a href="https://linkedin.com" style={{ color: '#3730A3' }}><FaLinkedinIn /></a>
            <a href="https://instagram.com" style={{ color: '#3730A3' }}><FaInstagram /></a>
            <a href="https://youtube.com" style={{ color: '#3730A3' }}><FaYoutube /></a>
          </div>
        </div>
      </MobileMenu>

      <ComingSoonModal 
        isOpen={showComingSoon} 
        onClose={() => setShowComingSoon(false)} 
      />
    </HeaderContainer>
  );
};
 
export default Header;